export default {
  employeeUSSTD: {
    name: 'employeeUSSTD',
    groups: [
      {
        title: 'Member Policy Details',
        fields: [
          {
            name: 'policy_id',
            span: 6,
          },
          {
            name: 'benefit_activation_date',
            span: 6,
          },
        ],
      },
      {
        title: 'Employer Policy Details',
        fields: [
          {
            name: 'parent.benefit_start_date',
            span: 6,
          },
          {
            name: 'parent.benefit_end_date',
            span: 6,
          },
          {
            name: 'parent.policy_id',
            span: 6,
          },
          {
            name: 'documents',
            span: 12,
          },
        ],
      },
      {
        title: 'Benefit Setup',
        fields: [
          {
            name: 'parent.prevent_default_allocation',
            span: 4,
          },
          {
            name: 'parent.opt_out',
            span: 4,
          },
          {
            name: 'parent.benefit_waiting_period_months',
            span: 4,
          },
        ],
      },
      {
        title: 'Benefit Expiry',
        fields: [
          {
            name: 'parent.benefit_available_grace_period_days',
            span: 6,
          },
          {
            name: 'parent.auto_renew',
            span: 6,
          },
        ],
      },
      {
        title: 'Description of Coverage',
        fields: [
          {
            name: 'parent.benefit_year',
            span: 6,
          },
          {
            name: 'parent.max_amount_basic',
            span: 6,
          },
          {
            name: 'parent.max_amount_major',
            span: 6,
          },
          {
            name: 'parent.basic_included',
            span: 6,
          },
          {
            name: 'parent.basic_reimbursement_percent',
            span: 6,
          },
          {
            name: 'parent.recall_service_frequency',
            span: 6,
          },
          {
            name: 'parent.recall_service_interval_months',
            span: 6,
          },
          {
            name: 'parent.major_restorative_included',
            span: 6,
          },
          {
            name: 'parent.dental_accident_reimbursement_percent',
            span: 6,
          },
          {
            name: 'parent.reimbursement_percent',
            span: 6,
          },
          {
            name: 'parent.eligibility',
            span: 6,
          },
          {
            name: 'parent.lifetime_maximum',
            span: 6,
          },
        ],
      },
      {
        title: 'Internal Fields',
        fields: [
          {
            name: 'id',
            span: 4,
          },
          {
            name: 'user_id',
            span: 4,
          },
          {
            name: 'parent.status',
            span: 4,
          },
          {
            name: 'grace_period_start_date',
            span: 4,
          },
          {
            name: 'inactive_date',
            span: 4,
          },
          {
            name: 'reinstated_date',
            span: 4,
          },
          {
            name: 'parent.provider_id',
            span: 4,
          },
          {
            name: 'parent.vendor',
            span: 4,
          },
          {
            name: 'parent.benefit_type',
            span: 4,
          },
          {
            name: 'parent.benefit_product_type',
            span: 4,
          },
          {
            name: 'parent.id',
            span: 4,
          },
          {
            name: 'parent.benefit_status',
            span: 4,
          },
          {
            name: 'parent.provider_type',
            span: 4,
          },
          {
            name: 'parent.plan_id',
            span: 4,
          },
          {
            name: 'parent.benefit_vendor_id',
            span: 4,
          },
          {
            name: 'parent.renewed_from',
            span: 4,
          },
        ],
      },
      {
        title: 'Advanced',
        fields: [
          {
            name: 'parent.plan_id',
            span: 6,
          },
          {
            name: 'parent.policy_id',
            span: 6,
          },
          {
            name: 'parent.prevent_default_allocation',
            span: 6,
          },
          {
            name: 'parent.weekly_benefit_flat_amount',
            span: 6,
          },

          {
            name: 'parent.weekly_benefit_percent_of_salary',
            span: 6,
          },

          {
            name: 'parent.weekly_benefit_graded_schedule_percent_first',
            span: 6,
          },

          {
            name: 'parent.weekly_benefit_graded_schedule_upper_first',
            span: 6,
          },

          {
            name: 'parent.weekly_benefit_graded_schedule_percent_second',
            span: 6,
          },

          {
            name: 'parent.weekly_benefit_graded_schedule_upper_second',
            span: 6,
          },

          {
            name: 'parent.weekly_benefit_graded_schedule_percent_remainder',
            span: 6,
          },

          {
            name: 'parent.maximum_benefit_amount',
            span: 6,
          },

          {
            name: 'parent.benefit_period_weeks',
            span: 6,
          },

          {
            name: 'parent.elimination_period_injury_days',
            span: 6,
          },

          {
            name: 'parent.elimination_period_sickness_days',
            span: 6,
          },

          {
            name: 'weekly_benefit_flat_amount',
            span: 6,
          },
        ],
      },
    ],
  },
};
